import _MoreHorizontalIcon from "@adsk/alloy-react-icon/es/lib/MoreHorizontalIcon";
const _excluded = ["breadcrumbs"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@adsk/alloy-react-button';
import { MenuList, MenuItem } from '@adsk/alloy-react-menu';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { Flyout } from '@adsk/alloy-react-tooltip';
import BreadcrumbWrapper from './BreadcrumbWrapper';
const renderIcon = p => /*#__PURE__*/React.createElement(_MoreHorizontalIcon, p);
const BreadcrumbPile = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      breadcrumbs = []
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const content = useMemo(() => /*#__PURE__*/React.createElement(MenuList, {
    style: {
      padding: 0
    }
  }, breadcrumbs.map(crumb => /*#__PURE__*/React.createElement(MenuItem, _extends({}, _objectSpread(_objectSpread({}, crumb), {}, {
    type: undefined
  }), {
    style: {
      padding: "0 ".concat(theme.spacing.XS, "px 0 0")
    },
    key: crumb.key
  })))), [breadcrumbs]);
  return /*#__PURE__*/React.createElement(BreadcrumbWrapper, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Flyout, {
    style: {
      padding: 0,
      width: 180
    },
    content: content,
    placement: Flyout.PLACEMENTS.BOTTOM
  }, /*#__PURE__*/React.createElement(IconButton, {
    style: {
      color: theme.tokens.colors.text.link.value
    },
    renderIcon: renderIcon
  })));
});
BreadcrumbPile.displayName = 'BreadcrumbPile';
BreadcrumbPile.propTypes = {
  /** The list of condensed crumbs to display */
  breadcrumbs: PropTypes.array,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string
};
export default BreadcrumbPile;
//# sourceMappingURL=BreadcrumbPile.js.map